module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-radio-group', {
    attrs: {
      "label": _vm.label,
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "align-top": "",
        "pa-1": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "shrink mt-0 mr-2",
      attrs: {
        "hide-details": "",
        "multiple": "",
        "input-value": _vm.active,
        "value": item[_vm.itemValue] || Object.values(item)[0],
        "disabled": item[_vm.itemDisabled]
      },
      on: {
        "change": _vm.onChange
      }
    }), _vm._v(" "), _c(_vm.createComp(item[_vm.itemText] || Object.values(item)[0]), {
      tag: "component"
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ef71c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SelectCheck.vue
// module id = 815
// module chunks = 1